// tiles.vetro.io services use a z value that is one lower than what mapbox provides
// therefore we need to decrement the z-value in the url - so e.g.,
// https://tiles.vetro.io/maps/tms/1.0.0/v_fiberrise_business_points/webmercator/9/259/614.png
// becomes https://tiles.vetro.io/maps/tms/1.0.0/v_fiberrise_business_points/webmercator/8/259/614.png
// we get the additional x & y values so that an errant non-coordinate /123/ in the url will not
// get decremented instead

import { v4 as uuid } from 'uuid';

export const decrementZoomInTileUrl = (url) =>
  url.replace(/\/(\d+)\/(\d+)\/(\d+)/, (__match, z, x, y) => {
    return `/${Number(z) - 1}/${x}/${y}`;
  });

export const vectorTileFeatureToVetroFeature = ({ vectorTileFeature, planId, layerId }) => {
  const feature = {
    geometry: vectorTileFeature.geometry,
    xVetro: {
      planId,
      layerId,
      vetroId: uuid(),
    },
    attributes: vectorTileFeature.properties,
  };

  if (vectorTileFeature.id !== undefined) {
    feature.xVetro.id = vectorTileFeature.id;
  }

  return feature;
};
